import { render, staticRenderFns } from "./GestionTurnosSemana.vue?vue&type=template&id=2b324740&scoped=true"
import script from "./GestionTurnosSemana.vue?vue&type=script&lang=js"
export * from "./GestionTurnosSemana.vue?vue&type=script&lang=js"
import style0 from "./GestionTurnosSemana.vue?vue&type=style&index=0&id=2b324740&prod&scoped=true&lang=css"
import style1 from "./GestionTurnosSemana.vue?vue&type=style&index=1&id=2b324740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b324740",
  null
  
)

export default component.exports